 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + "f4af886b" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-fa12cfa0":1,"chunk-031ba7be":1,"chunk-040632c8":1,"chunk-0507cfb0":1,"chunk-0578bc1c":1,"chunk-0fd56f08":1,"chunk-100c0382":1,"chunk-13bd0210":1,"chunk-1ad55163":1,"chunk-1b6e3bb1":1,"chunk-1baef912":1,"chunk-1cfd816b":1,"chunk-1dfe976a":1,"chunk-1ed9ae6e":1,"chunk-1ee29c5e":1,"chunk-23ef75b1":1,"chunk-26a52401":1,"chunk-2afe2b52":1,"chunk-73509018":1,"chunk-48713de2":1,"chunk-f3f7bf2e":1,"chunk-23bca363":1,"chunk-40da5643":1,"chunk-25fe84de":1,"chunk-2f43155e":1,"chunk-56bb24bb":1,"chunk-ac928556":1,"chunk-653fba60":1,"chunk-018c8059":1,"chunk-0567ecce":1,"chunk-0e032a0e":1,"chunk-3adc1a3c":1,"chunk-43a6a78c":1,"chunk-7664b838":1,"chunk-6a51db5a":1,"chunk-84328c8e":1,"chunk-9bef1d68":1,"chunk-2fd1ac86":1,"chunk-307e2643":1,"chunk-3a3820c7":1,"chunk-3b77f331":1,"chunk-3bb72f1b":1,"chunk-45680138":1,"chunk-4615ba4c":1,"chunk-466871c0":1,"chunk-4e6255de":1,"chunk-51008664":1,"chunk-57d53258":1,"chunk-34d70420":1,"chunk-547c808e":1,"chunk-63d4592c":1,"chunk-7b37a460":1,"chunk-b4fbb754":1,"chunk-f9b54c18":1,"chunk-64e48766":1,"chunk-68fe881e":1,"chunk-69568d93":1,"chunk-6a1ddb4e":1,"chunk-701bec56":1,"chunk-70e8658d":1,"chunk-71b779fe":1,"chunk-ef9984ca":1,"chunk-7619f172":1,"chunk-9201e956":1,"chunk-02a84450":1,"chunk-9c7d9a12":1,"chunk-8e29738a":1,"chunk-1b9518f8":1,"chunk-c6583ef8":1,"chunk-c8f6c7a6":1,"chunk-d2591790":1,"chunk-dcfe2a90":1,"chunk-e74e5752":1,"chunk-e7a92864":1,"chunk-fdbc0cbc":1,"chunk-ebcb2cde":1,"chunk-41c20742":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-023fb868":"31d6cfe0","chunk-fa12cfa0":"ade792a9","chunk-031ba7be":"228a108f","chunk-040632c8":"a37d274b","chunk-0507cfb0":"ae80c24e","chunk-0578bc1c":"1dd8358e","chunk-2d0ae9a7":"31d6cfe0","chunk-0c7b2c68":"31d6cfe0","chunk-0fd56f08":"28c24f36","chunk-100c0382":"c5081925","chunk-13bd0210":"995c8cd8","chunk-1ad55163":"048aad50","chunk-1b6e3bb1":"50881934","chunk-1baef912":"a81bfca5","chunk-1cfd816b":"b2fef914","chunk-1dfe976a":"96b24a5f","chunk-1ed9ae6e":"6a809503","chunk-1ee29c5e":"c978fb4a","chunk-23ef75b1":"2c099a52","chunk-26a52401":"fac7ca08","chunk-2afe2b52":"e202d755","chunk-2d0c510d":"31d6cfe0","chunk-73509018":"fc73785b","chunk-48713de2":"3a69ed0e","chunk-f3f7bf2e":"c644e0ae","chunk-23bca363":"9d9407b9","chunk-2d0b2b47":"31d6cfe0","chunk-40da5643":"37d42189","chunk-619d7aac":"31d6cfe0","chunk-25fe84de":"4572f514","chunk-2f43155e":"dc24919a","chunk-56bb24bb":"1ebe4e1d","chunk-ac928556":"f2510585","chunk-653fba60":"bd07c023","chunk-018c8059":"88a7fd25","chunk-0567ecce":"240717ef","chunk-0e032a0e":"d6fa9987","chunk-3adc1a3c":"466d3e3c","chunk-43a6a78c":"8ca27c89","chunk-7664b838":"982668aa","chunk-6a51db5a":"012d682d","chunk-7da8889c":"31d6cfe0","chunk-84328c8e":"710c3ab7","chunk-9bef1d68":"6b5f625d","chunk-2d0c8206":"31d6cfe0","chunk-2d0e9702":"31d6cfe0","chunk-2d0e991a":"31d6cfe0","chunk-2d0f028e":"31d6cfe0","chunk-2d20e788":"31d6cfe0","chunk-2d2160f1":"31d6cfe0","chunk-2d229afb":"31d6cfe0","chunk-2fd1ac86":"0886a3ec","chunk-307e2643":"0886a3ec","chunk-3a3820c7":"4dec8ecb","chunk-3b77f331":"8f37a07e","chunk-3bb72f1b":"bd637e2d","chunk-4463fdfe":"31d6cfe0","chunk-45680138":"414a2024","chunk-4615ba4c":"e05219fe","chunk-466871c0":"86b3894e","chunk-4e6255de":"92d4ab9e","chunk-51008664":"68426685","chunk-57d53258":"8a72cd40","chunk-34d70420":"ff4e1bbe","chunk-547c808e":"6752105c","chunk-63d4592c":"8825216f","chunk-7b37a460":"a2eb72b3","chunk-b4fbb754":"2fba676f","chunk-f9b54c18":"de989f6a","chunk-64e48766":"a2aad21b","chunk-68fe881e":"34c5d3fe","chunk-69568d93":"fdff0fbc","chunk-6a1ddb4e":"3197986e","chunk-701bec56":"07187c5e","chunk-70e8658d":"aa0703ae","chunk-71b779fe":"bcebd232","chunk-ef9984ca":"d1ac2c69","chunk-7619f172":"8a72cd40","chunk-9201e956":"eaa22e5d","chunk-02a84450":"7895acc1","chunk-9c7d9a12":"40b08173","chunk-8e29738a":"c978fb4a","chunk-1b9518f8":"82698ccf","chunk-c6583ef8":"5648740a","chunk-c8f6c7a6":"0886a3ec","chunk-cf3b0bda":"31d6cfe0","chunk-d2591790":"8d3c9cfb","chunk-dcfe2a90":"14972a5b","chunk-e74e5752":"2e8340e5","chunk-e7a92864":"0403342f","chunk-fdbc0cbc":"d13c34be","chunk-ebcb2cde":"30706fd1","chunk-41c20742":"05f78818"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdnstatic.gamekee.com/wiki/4.0/pc/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["a949","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
